export default {
  // 页面标题和面包屑
  'pages.guest.title': 'Guest Registration Management',
  'pages.guest.breadcrumb.person': 'Personnel Management',
  'pages.guest.breadcrumb.guest': 'Guest Registration',

  // 副标题配置
  'pages.guest.subtitle.canEnterEarly': 'After approval, you can enter',
  'pages.guest.subtitle.hoursEnter': 'hours early, if it exceeds',
  'pages.guest.subtitle.hoursCannotEnter': 'hours, you will not be able to enter the community',

  // 按钮
  'pages.guest.button.settings': 'Settings',

  // 模态框
  'pages.guest.modal.config.title': 'Guest Time Configuration',
  'pages.guest.modal.config.save': 'Save',
  'pages.guest.modal.config.cancel': 'Cancel',

  // 表单标签
  'pages.guest.form.beforeHours.label': 'Early Entry Time (Hours)',
  'pages.guest.form.beforeHours.placeholder': 'Please enter early entry time',
  'pages.guest.form.beforeHours.required': 'Please enter early entry time',
  'pages.guest.form.beforeHours.range': 'Please enter a number between 0-24',

  'pages.guest.form.afterHours.label': 'Timeout Limit (Hours)',
  'pages.guest.form.afterHours.placeholder': 'Please enter timeout limit',
  'pages.guest.form.afterHours.required': 'Please enter timeout limit',
  'pages.guest.form.afterHours.range': 'Please enter a number between 1-168',

  // 消息
  'pages.guest.message.configUpdateSuccess': 'Configuration updated successfully',
  'pages.guest.message.configUpdateFailed': 'Configuration update failed',

  // 表格相关
  'pages.guest.table.title': 'Guest Registration List',
  'pages.guest.table.columns.houseInfo': 'Visited Property',
  'pages.guest.table.columns.ownerName': 'Visited Owner',
  'pages.guest.table.columns.guestName': 'Guest Name',
  'pages.guest.table.columns.qrcode': 'QR Code',
  'pages.guest.table.columns.guestPhone': 'Contact Phone',
  'pages.guest.table.columns.visitTime': 'Visit Time',
  'pages.guest.table.columns.leaveTime': 'Leave Time',
  'pages.guest.table.columns.status': 'Status',
  'pages.guest.table.columns.createdTime': 'Created Time',
  'pages.guest.table.columns.remarks': 'Remarks',
  'pages.guest.table.columns.action': 'Action',

  // 按钮
  'pages.guest.button.create': 'New Registration',
  'pages.guest.button.view': 'View',
  'pages.guest.button.audit': 'Audit',
  'pages.guest.button.reject': 'Reject',
  'pages.guest.button.close': 'Close',

  // 详情模态框
  'pages.guest.detail.title': 'Guest Registration Details',
  'pages.guest.detail.sections.guestInfo': 'Guest Information',
  'pages.guest.detail.sections.visitInfo': 'Visit Information',
  'pages.guest.detail.sections.visitedInfo': 'Visited Information',
  'pages.guest.detail.sections.idCard': 'ID Photos',
  'pages.guest.detail.sections.systemInfo': 'System Information',

  // 字段标签
  'pages.guest.detail.fields.guestName': 'Guest Name',
  'pages.guest.detail.fields.guestPhone': 'Contact Phone',
  'pages.guest.detail.fields.idCard': 'ID Card Number',
  'pages.guest.detail.fields.visitTime': 'Visit Time',
  'pages.guest.detail.fields.leaveTime': 'Leave Time',
  'pages.guest.detail.fields.status': 'Guest Status',
  'pages.guest.detail.fields.remarks': 'Remarks',
  'pages.guest.detail.fields.houseInfo': 'Visited Property',
  'pages.guest.detail.fields.ownerName': 'Visited Owner',
  'pages.guest.detail.fields.ownerPhone': 'Owner Phone',
  'pages.guest.detail.fields.createdTime': 'Created Time',
  'pages.guest.detail.fields.updatedTime': 'Updated Time',

  // 状态相关
  'pages.guest.status.notLeave': 'Not Left',
  'pages.guest.status.none': '-',

  // 编辑/创建表单
  'pages.guest.form.create.title': 'New Guest Registration',
  'pages.guest.form.edit.title': 'Edit Guest Registration',
  'pages.guest.form.submit.create': 'Create',
  'pages.guest.form.submit.update': 'Update',
  'pages.guest.form.submit.cancel': 'Cancel',

  // 表单分区
  'pages.guest.form.sections.guestInfo': 'Guest Information',
  'pages.guest.form.sections.visitedInfo': 'Visited Information',
  'pages.guest.form.sections.visitTime': 'Visit Time',
  'pages.guest.form.sections.remarks': 'Remarks',

  // 表单字段
  'pages.guest.form.fields.guestName.label': 'Guest Name',
  'pages.guest.form.fields.guestName.placeholder': 'Please enter guest name',
  'pages.guest.form.fields.guestName.required': 'Please enter guest name',
  'pages.guest.form.fields.guestName.maxLength': 'Guest name cannot exceed 50 characters',

  'pages.guest.form.fields.guestPhone.label': 'Contact Phone',
  'pages.guest.form.fields.guestPhone.placeholder': 'Please enter contact phone',
  'pages.guest.form.fields.guestPhone.required': 'Please enter contact phone',

  'pages.guest.form.fields.idCard.label': 'ID Card Number',
  'pages.guest.form.fields.idCard.placeholder': 'Please enter ID card number',

  'pages.guest.form.fields.idCardPhoto.label': 'ID Photos',
  'pages.guest.form.fields.idCardPhoto.upload': 'Upload Image',
  'pages.guest.form.fields.idCardPhoto.uploading': 'Uploading',
  'pages.guest.form.fields.idCardPhoto.uploadError': 'ID photo upload failed',
  'pages.guest.form.fields.idCardPhoto.uploadSuccess': 'ID photo uploaded successfully',
  'pages.guest.form.fields.idCardPhoto.onlyImage': 'Only image files can be uploaded!',
  'pages.guest.form.fields.idCardPhoto.sizeLimit': 'Image size cannot exceed 5MB!',
  'pages.guest.form.fields.idCardPhoto.uploadHint': '{count} image(s) uploaded{emptyHint}',
  'pages.guest.form.fields.idCardPhoto.emptyHint': ', support uploading ID card front and back or other document photos',
  'pages.guest.form.fields.idCardPhoto.imageAlt': 'ID Photo {index}',

  'pages.guest.form.fields.houseInfo.label': 'Visited Property',
  'pages.guest.form.fields.houseInfo.placeholder': 'Please select visited property',
  'pages.guest.form.fields.houseInfo.search': 'Search',
  'pages.guest.form.fields.houseInfo.select': 'Auto-filled after property selection',

  'pages.guest.form.fields.ownerInfo.label': 'Visited Owner',
  'pages.guest.form.fields.ownerInfo.placeholder': 'Auto-filled after property selection',

  'pages.guest.form.fields.visitTime.label': 'Visit Time',
  'pages.guest.form.fields.visitTime.placeholder': 'Please select visit time',
  'pages.guest.form.fields.visitTime.required': 'Please select visit time',

  'pages.guest.form.fields.leaveTime.label': 'Leave Time',
  'pages.guest.form.fields.leaveTime.placeholder': 'Please select leave time',

  'pages.guest.form.fields.status.label': 'Guest Status',
  'pages.guest.form.fields.status.placeholder': 'Please select status',
  'pages.guest.form.fields.status.required': 'Please select status',

  'pages.guest.form.fields.remarks.label': 'Remarks',
  'pages.guest.form.fields.remarks.placeholder': 'Please enter remarks',

  // 消息提示
  'pages.guest.message.create.success': 'Created successfully',
  'pages.guest.message.create.failed': 'Creation failed, please try again later',
  'pages.guest.message.update.success': 'Updated successfully',
  'pages.guest.message.update.failed': 'Update failed, please try again later',
  'pages.guest.message.reject.success': 'Rejected',
  'pages.guest.message.reject.failed': 'Rejection failed',
  'pages.guest.message.audit.approve': 'Audit approved',
  'pages.guest.message.audit.reject': 'Rejected',
  'pages.guest.message.audit.failed': 'Audit failed, please try again later',
  'pages.guest.message.houseSelect.success': 'Property information auto-filled',
  'pages.guest.message.qrCode.configError': 'QR code URL configuration incomplete',
  'pages.guest.message.qrCode.downloadSuccess': 'QR code downloaded',
  'pages.guest.message.qrCode.copySuccess': 'QR code copied to clipboard',
  'pages.guest.message.qrCode.copyFailed': 'Copy failed, please use download function',
  'pages.guest.message.qrCode.elementNotFound': 'QR code element not found',
  'pages.guest.message.qrCode.copyFailedAlternative': 'Copy failed, please use download function or try manual operation',
  'pages.guest.message.guestInfoNotExist': 'Guest information does not exist',

  // 审核相关
  'pages.guest.audit.title': 'Guest Registration Audit',
  'pages.guest.audit.approve': 'Approve',
  'pages.guest.audit.reject': 'Reject',
  'pages.guest.audit.remarks.label': 'Audit Remarks',
  'pages.guest.audit.remarks.placeholder': 'Please enter audit remarks (optional)',
  'pages.guest.audit.confirm.approve': 'Confirm Approve',
  'pages.guest.audit.confirm.approve.description': 'Are you sure to approve this guest registration?',
  'pages.guest.audit.confirm.reject': 'Confirm Reject',
  'pages.guest.audit.confirm.reject.description': 'Are you sure to reject this guest registration?',

  // 二维码相关
  'pages.guest.qrCode.title': 'Guest QR Code',
  'pages.guest.qrCode.openLink': 'Open Link',
  'pages.guest.qrCode.copy': 'Copy QR Code',
  'pages.guest.qrCode.download': 'Download QR Code',
  'pages.guest.qrCode.linkLabel': 'Link URL:',

  // 表格分页
  'pages.guest.table.pagination.total': 'Total {total} records',

  // 默认状态文本
  'pages.guest.status.pending': 'Pending',
  'pages.guest.status.registered': 'Registered',
  'pages.guest.status.checked_in': 'Checked In',
  'pages.guest.status.checked_out': 'Checked Out',
  'pages.guest.status.rejected': 'Rejected',
  'pages.guest.status.entered': 'Entered',
  'pages.guest.status.left': 'Left',

  // Tooltip
  'pages.guest.tooltip.viewDetail': 'View Details',
  'pages.guest.tooltip.audit': 'Audit',
  'pages.guest.tooltip.reject': 'Reject',
  'pages.guest.tooltip.generateQrCode': 'Generate QR Code',
};
